import { __ } from '@wordpress/i18n';

export default {
	message: __( 'Estate Slider with Text', 'kam001-real-estate-blocks' ),
};
